import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext.js";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function StaffDashboard() {
  const { user, logout } = useAuth();
  const [patients, setPatients] = useState([]);
  const [activeTab, setActiveTab] = useState(1);

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  // Загрузка пациентов
  useEffect(() => {
    if (!user?.token) return;

    fetch(`${API_URL}/api/admin/pending`, {
      headers: { Authorization: "Bearer " + user.token },
    })
      .then((res) => res.json())
      .then((data) => {
        let list = [];
        if (Array.isArray(data)) list = data;
        else if (Array.isArray(data.patients)) list = data.patients;

        // Сортировка по последнему uploadedAt
        list.sort((a, b) => {
          const aDate = a.uploadedFiles?.length
            ? new Date(a.uploadedFiles[a.uploadedFiles.length - 1].uploadedAt)
            : new Date(0);
          const bDate = b.uploadedFiles?.length
            ? new Date(b.uploadedFiles[b.uploadedFiles.length - 1].uploadedAt)
            : new Date(0);
          return bDate - aDate; // новые сверху
        });

        setPatients(list);
      })
      .catch((err) => {
        console.error("Ошибка загрузки пациентов:", err);
        setPatients([]);
      });
  }, [user, API_URL]);

  // Скачивание файла пациента
  const handleDownloadFile = async (patient, file) => {
    if (!file) {
      console.error("Файл не указан");
      return;
    }
    if (!file.safeName) {
      console.error("У файла отсутствует safeName", file);
      return;
    }

    try {
      const res = await fetch(
        `${API_URL}/api/admin/download/${patient._id}/${file.safeName}`,
        {
          headers: { Authorization: "Bearer " + user.token },
        }
      );
      if (!res.ok) throw new Error("Ошибка загрузки");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = file.name; // оригинальное имя с кириллицей
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Ошибка скачивания:", err);
    }
  };

  // Загрузка справки
  const handleUploadCertificate = async (patientId, e) => {
    const formData = new FormData();
    formData.append("certificate", e.target.files[0]);

    try {
      const res = await fetch(
        `${API_URL}/api/admin/upload-certificate/${patientId}`,
        {
          method: "POST",
          headers: { Authorization: "Bearer " + user.token },
          body: formData,
        }
      );
      if (!res.ok) throw new Error("Ошибка загрузки");
      const data = await res.json();

      // Обновляем пациента локально с правильным safeName
      setPatients((prev) =>
        prev.map((p) =>
          p._id === patientId
            ? { ...p, certificate: data.certificate } // ⚡ используем данные с сервера
            : p
        )
      );

      alert("Справка загружена!");
    } catch (err) {
      console.error(err);
      alert("Не удалось загрузить справку");
    }
  };

  // Фильтры
  const patientsWithStatementNoCertificate = patients.filter(
    (p) => p.uploadedFiles?.length > 0 && !p.certificate
  );
  const patientsWithStatementAndCertificate = patients.filter(
    (p) => p.uploadedFiles?.length > 0 && p.certificate
  );

  const renderPatients = () => {
    let list = [];
    if (activeTab === 1) list = patientsWithStatementNoCertificate;
    else if (activeTab === 2) list = patientsWithStatementAndCertificate;
    else list = patients;

    if (list.length === 0)
      return <p className="staff__label">Пациенты не найдены</p>;

    return list.map((p) => {
      const highlight = !p.certificate && p.uploadedFiles?.length > 0;
      return (
        <div
          key={p._id}
          style={{
            border: "1px solid #ccc",
            margin: "10px",
            padding: "10px",
            backgroundColor: highlight ? "#fff8dc" : "#f3f9ff",
          }}
        >
          <p className="login__label">
            ФИО: <br></br>
            {p.fullName} <br></br> {p.birthDate} г.р.
          </p>

          {p.uploadedFiles?.length > 0 && (
            <>
              <p className="login__label">
                Заявления на получение справки для налоговой:
              </p>
              <ul className="staff__ul">
                {p.uploadedFiles.map((f, i) => (
                  <li className="staff__li" key={i}>
                    <p className="staff__label">{i + 1}</p>
                    <button
                      className="staff__btn"
                      onClick={() => handleDownloadFile(p, f)}
                    >
                      {f.name} ({new Date(f.uploadedAt).toLocaleDateString()})
                    </button>
                  </li>
                ))}
              </ul>
            </>
          )}

          <p className="login__label">Загруженная справка:</p>
          {!p.certificate && p.uploadedFiles?.length > 0 && (
            <input
              type="file"
              className="field"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.bmp"
              onChange={(e) => handleUploadCertificate(p._id, e)}
            />
          )}

          {p.certificate && (
            <button
              className="staff__btn_spr"
              onClick={() => handleDownloadFile(p, p.certificate)}
            >
              Справка: {p.certificate.name}
            </button>
          )}
        </div>
      );
    });
  };

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Кабинет сотрудника
      </h1>

      <div className="div__upper">
        <button
          className={`staff__button ${activeTab === 1 ? "btn--active" : ""}`}
          onClick={() => setActiveTab(1)}
        >
          Заявления без справки ({patientsWithStatementNoCertificate.length})
        </button>
        <button
          className={`staff__button ${activeTab === 2 ? "btn--active" : ""}`}
          onClick={() => setActiveTab(2)}
        >
          Заявления со справкой ({patientsWithStatementAndCertificate.length})
        </button>
        <button
          className={`staff__button ${activeTab === 3 ? "btn--active" : ""}`}
          onClick={() => setActiveTab(3)}
        >
          Все пациенты ({patients.length})
        </button>
      </div>

      {renderPatients()}

      <button onClick={logout} className="btn btn--secondary">
        Выйти
      </button>
    </section>
  );
}
